import { usePathname } from 'expo-router';
import React from 'react';
import { ActivityIndicator, Text } from 'react-native';

import { SignInForm } from '@/components/SignInForm';
import { ThemedView } from '@/components/ThemedView';
import { useAuth } from '@/hooks/useAutoLogin';

export function AuthGate({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, error, tokenRedemptionInProgress } = useAuth();
  const pathname = usePathname();

  // Allow idpresponse route to render without authentication checks
  // This route needs access to AuthProvider to check authentication status
  if (pathname === '/idpresponse') {
    return <>{children}</>;
  }

  // Show loading state during initial authentication check or token redemption
  if (isLoading || tokenRedemptionInProgress) {
    return (
      <ThemedView style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <ActivityIndicator size="large" />
        <Text style={{ marginTop: 10 }}>
          {tokenRedemptionInProgress ? 'Processing access token...' : 'Authenticating...'}
        </Text>
      </ThemedView>
    );
  }

  if (!isAuthenticated) {
    return (
      <ThemedView style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <SignInForm />
        {error && <Text style={{ color: 'red', marginTop: 10 }}>{error}</Text>}
      </ThemedView>
    );
  }

  return <>{children}</>;
} 